import { render, staticRenderFns } from "./_galleryId.vue?vue&type=template&id=4da82e4b&"
import script from "./_galleryId.vue?vue&type=script&lang=ts&"
export * from "./_galleryId.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports